// extracted by mini-css-extract-plugin
export default {"button":"MCWrapper__button--Hyrfn","content":"MCWrapper__content--pxbb1","typeTitle":"MCWrapper__typeTitle--EqsjO","icon":"MCWrapper__icon--ljwIU"};